<template>
    <FormModal :model="model" :init="init" modal-id="item" :beforeSaving="beforeSaving" :onSetIsEditMode="onSetIsEditMode" @save="$emit('save', $event)" @destroy="$emit('destroy', $event)" :is-enabled-view-mode="false">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">同期ON/OFF</strong>
                </div>
                <div class="d-flex justify-content-end">
                    <span class="mr-2">OFF</span>
                    <b-form-checkbox
                        v-model="model.status"
                        value="activated"
                        unchecked-value="suspended"
                        switch
                        >
                    </b-form-checkbox>
                    <span>ON</span>
                </div>
                <input-error :errors="error.status" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">複数在庫/一品物</strong>
                </div>
                <div class="d-flex justify-content-end">
                    <span class="mr-2">{{ trans.labels['user_items.is_single.false'] }}</span>
                    <b-form-checkbox
                        v-model="model.is_single"
                        switch
                        >
                    </b-form-checkbox>
                    <span>{{ trans.labels['user_items.is_single.true'] }}</span>
                </div>
                <input-error :errors="error.status" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">同期対象SKU</strong>
                </div>
                <b-row>
                    <b-col>
                        <h5>Inventory</h5>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td class="px-0">
                                        <small>Amazon US</small>
                                        <b-form-input v-model="model.user_item_caches_sku.amazon" placeholder=""></b-form-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">
                                        <small>Amazon CA</small>
                                        <b-form-input v-model="model.user_item_caches_sku.amazon_ca" placeholder=""></b-form-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">
                                        <small>Amazon AU</small>
                                        <b-form-input v-model="model.user_item_caches_sku.amazon_au" placeholder=""></b-form-input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col>
                        <h5>Store</h5>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td class="px-0">
                                        <small>eBay</small>
                                        <b-form-input v-model="model.user_item_caches_sku.ebay" placeholder=""></b-form-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">
                                        <small>eBay CA</small>
                                        <b-form-input v-model="model.user_item_caches_sku.ebay_ca" placeholder=""></b-form-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">
                                        <small>eBay AU</small>
                                        <b-form-input v-model="model.user_item_caches_sku.ebay_au" placeholder=""></b-form-input>
                                    </td>
                                </tr>
<!--
                                <tr>
                                    <td class="px-0">
                                        <small>Woo</small>
                                        <b-form-input v-model="model.user_item_caches_sku.woo" placeholder=""></b-form-input>
                                    </td>
                                </tr>
-->
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <input-error :errors="error.user_item_caches_id" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">在庫数調整オプション</strong>
                </div>
                <template v-if="model.is_single">
                    設定項目はありません。
                </template>
                <template v-else>
                    <b-row>
                        <b-col>
                            <p><strong>在庫補充最低条件</strong></p>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col>
                            <div class="d-flex justify-content-end">
                                <b-form-input v-model="model.condition_to_replenish" type="number" class="text-right" min="1"></b-form-input>
                            </div>
                            <div class="text-secondary"><small>合計Inventory在庫数が設定値より小さい場合、在庫補充の同期をせず、在庫削減の同期のみを行います。十分に大きな値にすると、在庫補充がされなくなるので、Amazon在庫数にタイムラグによる誤った在庫補充が起こりにくくなります。</small><small class="text-danger">在庫数が少ない商品の場合は、必ず設定してください。</small></div>
                            <div class="text-secondary"><small>例）在庫補充最低条件「10」を設定した場合、
                                <br>・FBA在庫数:9, eBay在庫数:3 → eBay在庫数:3
                                <br>・FBA在庫数:10, eBay在庫数:3 → eBay在庫数:10
                            </small></div>
                            <input-error :errors="error.condition_to_replenish" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p><strong>在庫数マージン</strong></p>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col>
                            <div class="d-flex justify-content-end">
                                <b-form-input v-model="model.margin" type="number" class="text-right" min="0"></b-form-input>
                            </div>
                            <div class="text-secondary"><small>合計Inventory在庫数 − 在庫数マージンの数が同期されます。同期処理には時間差があるため、十分に大きな値にすると在庫切れが起こりにくくなります。</small></div>
                            <input-error :errors="error.margin" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p><strong>最大在庫数</strong></p>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col>
                            <div class="d-flex justify-content-end">
                                <b-form-input v-model="model.max" type="number" class="text-right" min="1"></b-form-input>
                            </div>
                            <div class="text-secondary"><small>Selling Limit節約のため</small></div>
                            <input-error :errors="error.max" />
                        </b-col>
                    </b-row>
                </template>

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">詳細設定</strong>
                </div>
                <b-row>
                    <b-col>
                        <p><strong>Amazon</strong></p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        配送スピード
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <b-form-radio-group
                            v-model="model.details.amazon.shipping_speed_category"
                            :options="[
                                { text: '通常配送', value: 'Standard', },
                                { text: 'お急ぎ便', value: 'Expedited', },
                                { text: '優先配送', value: 'Priority', },
                            ]"
                            button-variant="outline-secondary"
                            buttons
                            >
                        </b-form-radio-group>
                    </b-col>
                </b-row>
<div v-show="auth_level >= 200">
<!--
                <b-row>
                    <b-col>
                        <p><strong>Woo</strong></p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        商品データ同期
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <b-form-radio-group
                            v-model="model.details.woo.sync_data"
                            :options="[
                                { text: 'なし', value: '', },
                                { text: 'Amazonから', value: 'amazon', },
                                { text: 'eBayから', value: 'ebay', },
                            ]"
                            button-variant="outline-secondary"
                            buttons
                            >
                        </b-form-radio-group>
                        <p class="text-secondary"><small>商品名</small></p>
                    </b-col>
                </b-row>
-->
</div>
                <input-error :errors="error.data" />






<!--
<div v-show="auth_level >= 200">
                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">商品情報</strong>
                </div>
                <b-row>
                    <b-col>
                        <p><strong>eBay</strong></p>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="3">
                        タイトル
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <b-form-input v-model="model.listings.ebay.title" placeholder="title"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="3">
                        カテゴリー
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <ItemCategory
                            provider="ebay"
                            v-model="model.listings.ebay.category_id"
                            @input="onInputCategoryId"
                            />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col sm="3">
                        商品の詳細
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <ItemSpecifics
                            provider="ebay"
                            v-model="model.listings.ebay.item_specifics"
                            @input=""
                            />

<br>
1<br>
{{ model.listings.ebay.item_specifics }}
                    </b-col>
                </b-row>
</div>
-->
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<!--
                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">同期対象</strong>
                </div>
                <b-row>
                    <b-col>
                        <h5>Inventory</h5>
                        <table class="table table-hover">
                            <tbody>
                                <tr v-if="model.user_item_caches.amazon">
                                    <td class="px-0">
                                        <ItemDataAmazon :model="model.user_item_caches.amazon" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                                <tr v-if="model.user_item_caches.amazon_au">
                                    <td class="px-0">
                                        <ItemDataAmazon :model="model.user_item_caches.amazon_au" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                                <tr v-if="model.user_item_caches.amazon_ca">
                                    <td class="px-0">
                                        <ItemDataAmazon :model="model.user_item_caches.amazon_ca" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col>
                        <h5>Store</h5>
                        <table class="table table-hover">
                            <tbody>
                                <tr v-if="model.user_item_caches.ebay">
                                    <td class="px-0">
                                        <ItemDataEbay :model="model.user_item_caches.ebay" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                                <tr v-if="model.user_item_caches.ebay_au">
                                    <td class="px-0">
                                        <ItemDataEbay :model="model.user_item_caches.ebay_au" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                                <tr v-if="model.user_item_caches.ebay_ca">
                                    <td class="px-0">
                                        <ItemDataEbay :model="model.user_item_caches.ebay_ca" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                                <tr v-if="model.user_item_caches.woo">
                                    <td class="px-0">
                                        <ItemDataWoo :model="model.user_item_caches.woo" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <input-error :errors="error.user_item_caches_id" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">候補</strong>
                </div>
                <b-row>
                    <b-col>
                        <h5>Country</h5>
                        <b-form-group>
                            <b-form-radio-group
                                v-model="filters.country"
                                @change="changeBigFilter"
                                >
                                <b-form-radio :value="null">all</b-form-radio>
                                <b-form-radio value="US">US</b-form-radio>
                                <b-form-radio value="CA">CA</b-form-radio>
                                <b-form-radio value="AU">AU</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h5>Inventory</h5>
                        <GridPage
                            ref="gridPageInventory"
                            :form-default="{
                            }"
                            :filters-default="{
                                provider: 'amazon,amazon_au,amazon_ca',
                                quantity: '',
                                sort: 'name',
                            }"
                            :filter-items="[
                                {
                                    vModel: 'provider',
                                    title: 'サイト',
                                    options: [
                                        { text: '全て', value: 'amazon,amazon_au,amazon_ca' },
                                        { text: 'amazon_us', value: 'amazon' },
                                        { text: 'amazon_au', value: 'amazon_au' },
                                        { text: 'amazon_ca', value: 'amazon_ca' },
                                    ],
                                },
                                {
                                    vModel: 'quantity',
                                    title: '在庫',
                                    options: [
                                        { text: '全て', value: '' },
                                        { text: 'あり', value: '1' },
                                        { text: 'なし', value: '0' },
                                    ],
                                },
                                {
                                    vModel: 'sort',
                                    title: '順番',
                                    options: [
                                        { text: '▲ 名前', value: 'name', },
                                        { text: '▼ 名前', value: '-name', },
                                        { text: '▲ 在庫', value: 'quantity', },
                                        { text: '▼ 在庫', value: '-quantity', },
                                    ],
                                },
                            ]"
                            filters-q-placeholder="Name, SKU, ASIN"
                            form-modal-id="item_cache"
                            search-action="item_cache/index"
                            :hide-add="true"
                            :row-clicked="false"
                            :filter-search-results="filterSearchResults"
                            >
                            <template v-slot:form="{ form, init }">
                            </template>

                            <template v-slot:column="{ item }">
                                <ItemDataAmazon :model="item" v-if="item.provider === 'amazon'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataAmazon :model="item" v-if="item.provider === 'amazon_au'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataAmazon :model="item" v-if="item.provider === 'amazon_ca'" :toggle-synced-switch="toggleSyncedSwitch" />
                            </template>
                        </GridPage>
                    </b-col>
                    <b-col>
                        <h5>Store</h5>
                        <GridPage
                            ref="gridPageStore"
                            :form-default="{
                            }"
                            :filters-default="{
                                provider: 'ebay,ebay_au,ebay_ca,woo',
                                quantity: '',
                                sort: 'name',
                            }"
                            :filter-items="[
                                {
                                    vModel: 'provider',
                                    title: 'サイト',
                                    options: [
                                        { text: '全て', value: 'ebay,ebay_au,ebay_ca,woo' },
                                        { text: 'ebay_us', value: 'ebay' },
                                        { text: 'ebay_au', value: 'ebay_au' },
                                        { text: 'ebay_ca', value: 'ebay_ca' },
                                        { text: 'woo', value: 'woo' },
                                    ],
                                },
                                {
                                    vModel: 'quantity',
                                    title: '在庫',
                                    options: [
                                        { text: '全て', value: '' },
                                        { text: 'あり', value: '1' },
                                        { text: 'なし', value: '0' },
                                    ],
                                },
                                {
                                    vModel: 'sort',
                                    title: '順番',
                                    options: [
                                        { text: '▲ 名前', value: 'name', },
                                        { text: '▼ 名前', value: '-name', },
                                        { text: '▲ 在庫', value: 'quantity', },
                                        { text: '▼ 在庫', value: '-quantity', },
                                    ],
                                },
                            ]"
                            filters-q-placeholder="Name, SKU, ASIN"
                            form-modal-id="item_cache"
                            search-action="item_cache/index"
                            :hide-add="true"
                            :row-clicked="false"
                            :filter-search-results="filterSearchResults"
                            >
                            <template v-slot:form="{ form, init }">
                            </template>

                            <template v-slot:column="{ item }">
                                <ItemDataEbay :model="item" v-if="item.provider === 'ebay'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataEbay :model="item" v-if="item.provider === 'ebay_au'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataEbay :model="item" v-if="item.provider === 'ebay_ca'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataWoo :model="item" v-if="item.provider === 'woo'" :toggle-synced-switch="toggleSyncedSwitch" />
                            </template>
                        </GridPage>
                    </b-col>
                </b-row>
-->
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemDataAmazon from '@/components/ItemDataAmazon.vue'
import ItemDataEbay from '@/components/ItemDataEbay.vue'
import ItemDataWoo from '@/components/ItemDataWoo.vue'
import ItemCategory from '@/components/ItemCategory.vue'
import ItemSpecifics from '@/components/ItemSpecifics.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        InputError,
        ItemDataAmazon,
        ItemDataEbay,
        ItemDataWoo,
        ItemCategory,
        ItemSpecifics,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            timer: null,
            key: 0,
            _: {
            },
            filters: {
                country: null,
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ])
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
/*
        toggleSyncedSwitch(item) {
            if (item.synced) {
                this.$set(this.model.user_item_caches, item.provider, item)
            } else {
                this.$delete(this.model.user_item_caches, item.provider)
            }
            this.interval()
        },
        filterSearchResults(response) {
            this.interval()
            return response
        },
        changeBigFilter() {
            this.$refs.gridPageInventory.grid.filters.country = this.filters.country
            this.$refs.gridPageStore.grid.filters.country = this.filters.country

            console.log(this.$refs.gridPageInventory.search())
            console.log(this.$refs.gridPageStore.search())
        },
        interval() {
            if (!this.model.user_item_caches) {
                return
            }

            this.setStateToggleSyncedSwitch()
        },
        getSkusToggleSyncedSwitch() {
            const skus = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                skus.push(this.model.user_item_caches[keys[i]].provider + ':' + this.model.user_item_caches[keys[i]].sku)
            }
            return skus
        },
        getUuidsToggleSyncedSwitch() {
            const uuids = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                uuids.push(this.model.user_item_caches[keys[i]].uuid)
            }
            return uuids
        },
        setStateToggleSyncedSwitch() {
            const uuids = this.getUuidsToggleSyncedSwitch()

            // synced
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                this.$set(this.model.user_item_caches[keys[i]], 'synced', true)
            }

            // grid
            if (this.$refs.gridPageInventory.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageInventory.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageInventory.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageInventory.grid.response.data.hits[i].uuid) >= 0)
                }
            }
            if (this.$refs.gridPageStore.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageStore.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageStore.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageStore.grid.response.data.hits[i].uuid) >= 0)
                }
            }
        },
*/
        async onInputCategoryId () {
console.log('onInputCategoryId')
console.log(this.model.listings.ebay.category_id)

            let category = await this.$store
                .dispatch('item_category/search', {
                    provider: 'ebay',
                    query: this.model.listings.ebay.category_id,
                })
                .then((response) => {
                    return response.data.data.hits
                })
                .catch((error) => {
                    return []
                })
            if (category.length) {
                this.$utils.empty(this.model.listings.ebay.item_specifics)
                this.$utils.set(this.model.listings.ebay.item_specifics, category[0].value)
console.log(category)
            }
        },

        beforeSaving (model) {
            let data = {}

            data.user_item_caches_id = [];
            for (let provider in this.model.user_item_caches_sku) {
                let sku = this.model.user_item_caches_sku[provider]
                sku = sku.trim()
                if (!sku) {
                    continue
                }
                data.user_item_caches_id.push(provider + ':' + sku)
//                alert('key:' + key + ' value:' + hash[key]);
            }
//            data.user_item_caches_id = this.getSkusToggleSyncedSwitch()

            return Object.assign(model, data)
        },
        onSetIsEditMode (model) {
            if (model.is_edit_mode) {
                if (model.images.length) {
                    setTimeout(() => {
                        this.fixImage(model.images[0])
                    }, 1000)
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
</style>

